import React, { useState } from 'react';
import Modal from './Modal';
import { authAPI } from '../services/api';
import './ChangePasswordModal.css';

const ChangePasswordModal = ({ onClose, onSuccess, onError }) => {
    const [formData, setFormData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (formData.newPassword !== formData.confirmPassword) {
            return onError('La nueva contraseña y la confirmación no coinciden.');
        }
        
        try {
            setLoading(true);
            const response = await authAPI.changePassword({
                currentPassword: formData.currentPassword,
                newPassword: formData.newPassword
            });
            onSuccess(response.data.message || 'Contraseña actualizada exitosamente');
            onClose();
        } catch (error) {
            onError(error.response?.data?.message || 'Error al cambiar la contraseña');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal title="Cambiar Contraseña" onClose={onClose}>
            <form onSubmit={handleSubmit} className="change-password-form">
                <div className="password-form-group">
                    <label>Contraseña Actual *</label>
                    <input 
                        type="password" 
                        name="currentPassword" 
                        value={formData.currentPassword} 
                        onChange={handleChange} 
                        required 
                    />
                </div>
                
                <div className="password-form-group">
                    <label>Nueva Contraseña *</label>
                    <input 
                        type="password" 
                        name="newPassword" 
                        value={formData.newPassword} 
                        onChange={handleChange} 
                        required 
                        minLength={6}
                    />
                </div>
                
                <div className="password-form-group">
                    <label>Confirmar Nueva Contraseña *</label>
                    <input 
                        type="password" 
                        name="confirmPassword" 
                        value={formData.confirmPassword} 
                        onChange={handleChange} 
                        required 
                        minLength={6}
                    />
                </div>
                
                <div className="password-form-actions">
                    <button type="button" onClick={onClose} className="btn-cancel" disabled={loading}>
                        Cancelar
                    </button>
                    <button type="submit" className="btn-save" disabled={loading}>
                        {loading ? 'Guardando...' : 'Guardar Cambios'}
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default ChangePasswordModal;
